import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import { FaBuilding } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { BsFillBriefcaseFill } from "react-icons/bs";
import user1 from "../../../assets/images/users/user-logo.jpeg";

const ProfileMenu = props => {
  const [menu, setMenu] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const [username, setusername] = useState(user.firstName);
  const [isProfileOpen, setIsProfileOpen] = useState(false);

  const toggleProfile = () => {
    setIsProfileOpen(!isProfileOpen);
  };

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setusername(obj.email);
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setusername(obj.username);
      }
    }
  }, [props.success]);

  const logout = () => {
    localStorage.clear();
  }

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"

            src={user1}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-2 me-1">Hello {username}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem onClick={toggleProfile}>
            <DropdownItem isOpen={isProfileOpen} toggle={toggleProfile} className="p-0">
              <div>
              <p  className="mb-1" style={{fontSize:"15px",textTransform: "uppercase",fontWeight: "600"}}>{user.firstName} {user?.lastName || " "}<br /> </p>
              </div>
              <div className="d-flex  align-items-center ">
              <MdEmail className="me-1" style={{color:"#344fa0"}} />
              <p className="my-1 text-secondary "style={{fontSize:"12px"}}>{user.email}<br />  </p>
              </div>
              <div className="d-flex  align-items-center ">
              <BsFillBriefcaseFill className="me-1" style={{color:"#344fa0"}} />
              <p className="my-1 text-secondary "style={{fontSize:"12px"}}>{user.roleName} <br />  </p>
              </div>
              <div className="d-flex  align-items-center ">
              <FaBuilding className="me-1" style={{color:"#344fa0"}} />
              <p className="my-1 text-secondary "style={{fontSize:"12px"}}>{user.entityName} </p>  
              </div>

            </DropdownItem>
          </DropdownItem>
          <div className="dropdown-divider" />
          <Link to="/login" onClick={() => logout()} className="dropdown-item d-flex justify-content-center ">
            <i className="bx bx-power-off font-size-16 align-middle me-1  text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);